import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Checkbox
} from '@mui/material';
import MyButton from './MyButton';
import noDataImage from '../assets/images/undraw_Empty_re_opql.png';
import { printTable } from '../services/utils';

function MyTable({ headers, data, actions = [], defaultPageSize = 5, onPageChange, totalRows ,printOptions}) {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
    if (onPageChange) {
      onPageChange(newPage, rowsPerPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0);
    if (onPageChange) {
      onPageChange(0, newRowsPerPage);
    }
  };

  const paginatedData = data; // Adjust to fetch current page data if necessary.

  if (data.length === 0) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <img
          src={noDataImage}
          alt="No Data"
          style={{
            width: '100%',
            maxWidth: '500px',
            height: 'auto',
            margin: '20px auto',
            display: 'block',
          }}
        />
        <h2>No Records Found</h2>
      </div>
    );
  }

  return (
    <Paper elevation={5}>
      <button
        style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '10px 20px',
          margin: '10px',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
        onClick={() => printTable(data, headers,printOptions)} 
        >Print</button>

      <TableContainer sx={{ width: '100%' }}>
        <Table sx={{ minWidth: 250 }} size="small">
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableCell key={header.key}>
                  <strong>{header.label.toUpperCase()}</strong>
                </TableCell>
              ))}
              {actions.length > 0 && <TableCell width={200}></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row, index) => (
              <TableRow key={index}>
                {headers.map((header) => (
                  <TableCell key={header.key}>
                    {header.render ? (
                      header.render(row)
                    ) : (
                      typeof row[header.key] === 'boolean' ? (
                        <Checkbox checked={row[header.key]} disabled color="primary" />
                      ) : (
                        row[header.key]
                      )
                    )}
                  </TableCell>
                ))}
                {actions.length > 0 && (
                  <TableCell>
                    {actions.map((action, i) => (
                      <MyButton
                        key={i}
                        type={action.type}
                        action={action.action}
                        onClick={() => action.callback(row)}
                        style={{
                          padding: '5px 10px',
                          margin: '0 5px',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                        }}
                      >
                        {action.label}
                      </MyButton>
                    ))}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 20, 50,100,500,1000]}
        labelRowsPerPage="Rows per page"
        showFirstButton
        showLastButton
        
      />
    </Paper>
  );
}

export default MyTable;
